/**
 * Next.js 15 client instrumentation — browser Sentry init.
 *
 * Replaces sentry.client.config.ts.
 * Loaded once in the browser on page load.
 *
 * @see https://nextjs.org/docs/app/building-your-application/optimizing/instrumentation#client-instrumentation
 */
;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/devices/:id\",\"regex\":\"^/devices/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/time/timesheets/:id\",\"regex\":\"^/time/timesheets/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/invite/:token\",\"regex\":\"^/invite/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/confirm-email\"},{\"path\":\"/login\"},{\"path\":\"/register\"},{\"path\":\"/activity\"},{\"path\":\"/dashboard\"},{\"path\":\"/devices\"},{\"path\":\"/pair\"},{\"path\":\"/payroll\"},{\"path\":\"/payroll/me\"},{\"path\":\"/payroll/rates\"},{\"path\":\"/payroll/rules\"},{\"path\":\"/people\"},{\"path\":\"/people/approvals\"},{\"path\":\"/people/approvals/cant-make-it\"},{\"path\":\"/people/approvals/shift-swaps\"},{\"path\":\"/people/employees\"},{\"path\":\"/people/time-off\"},{\"path\":\"/settings\"},{\"path\":\"/time\"},{\"path\":\"/time/clock-log\"},{\"path\":\"/time/schedule\"},{\"path\":\"/time/timesheets\"},{\"path\":\"/time/timesheets/new\"},{\"path\":\"/work\"},{\"path\":\"/work/assets\"},{\"path\":\"/work/projects\"},{\"path\":\"/work/tasks\"},{\"path\":\"/clock\"},{\"path\":\"/cross-app\"},{\"path\":\"/kiosk/sauna-week\"},{\"path\":\"/me\"},{\"path\":\"/me/availability\"},{\"path\":\"/me/cant-make-it\"},{\"path\":\"/me/schedule\"},{\"path\":\"/me/shift-swaps\"},{\"path\":\"/no-tenant-access\"},{\"path\":\"/onboarding\"},{\"path\":\"/onboarding/accept\"},{\"path\":\"/onboarding/complete\"},{\"path\":\"/onboarding/create\"},{\"path\":\"/onboarding/invite\"},{\"path\":\"/onboarding/verify-email\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "15.5.25";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ?? 'development',

  // Capture 10% of transactions for performance monitoring.
  tracesSampleRate: parseFloat(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? '0.1'),

  // Replay 1% of sessions; 100% of sessions with errors.
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,

  // Never send PII automatically.
  sendDefaultPii: false,

  beforeSend(event) {
    const PII_KEYS = new Set([
      'email',
      'first_name',
      'last_name',
      'full_name',
      'phone',
      'address',
      'date_of_birth',
      'tag_uid',
      'serial_number',
      'password',
      'token',
      'access',
      'refresh',
    ]);

    function scrub(obj: unknown, depth = 0): unknown {
      if (depth > 8 || obj === null || obj === undefined) return obj;
      if (typeof obj === 'object' && !Array.isArray(obj)) {
        return Object.fromEntries(
          Object.entries(obj as Record<string, unknown>).map(([k, v]) => [
            k,
            PII_KEYS.has(k.toLowerCase()) ? '[Filtered]' : scrub(v, depth + 1),
          ])
        );
      }
      if (Array.isArray(obj)) return obj.map((item) => scrub(item, depth + 1));
      return obj;
    }

    if (event.request?.data) {
      event.request.data = scrub(event.request.data) as typeof event.request.data;
    }
    if (event.extra) {
      event.extra = scrub(event.extra) as typeof event.extra;
    }
    // Keep user context to id only.
    if (event.user) {
      event.user = { id: event.user.id };
    }
    return event;
  },
});
